import React from 'react';
import PropTypes from 'prop-types';
import {
  FlatButton,
  Dialog,
  CircularProgress,
} from 'material-ui';
import {
  translate as t,
} from 'admin-on-rest';
import ContentSave from 'material-ui/svg-icons/content/save';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import withConfirmDialog from '../Quiz/Hocs/withConfirmDialog';

const ButtonWithConfirmation = withConfirmDialog(FlatButton);

const Spinner = () => (
  <div
    style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      background: 'white',
      zIndex: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress size={80} />
  </div>
);

const styles = {
  baseContainer: {
    overflowY: 'scroll',
  },
};

class DialogForm extends React.PureComponent {
  state = {
    showSpinner: false,
  }

  showSpinner = () => {
    this.setState({
      showSpinner: true,
    });
  }

  hideSpinner = () => {
    this.setState({
      showSpinner: false,
    });
  }

  save = () => {
    if (!this.state.showSpinner) {
      const result = this.props.onSave();
      if (result instanceof Promise) {
        this.showSpinner();
        result
          .then(this.hideSpinner)
          .catch(this.hideSpinner);
      }
    }
  }

  render() {
    const {
      icon, title, translate,
      open, children, style,
      onRemove, confirmRemoveText, confirmRemoveTitle,
      confirmSaveText, confirmSaveTitle, confirmOnSave,
      onClose,
    } = this.props;
    const titleNode = (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {icon}
        {title || ''}
      </div>
    );
    const removeAction = (
      <ButtonWithConfirmation
        style={{
          position: 'absolute',
          left: 8,
        }}
        icon={<DeleteIcon />}
        label={`${translate('remove')} "${title}"`}
        primary
        confirmationTitle={confirmRemoveTitle}
        confirmationText={confirmRemoveText}
        submitText={translate('remove')}
        onClick={onRemove}
      />
    );
    const saveAction = confirmOnSave ? (
      <ButtonWithConfirmation
        icon={<ContentSave />}
        label={translate('save')}
        primary
        confirmationTitle={confirmSaveTitle}
        confirmationText={confirmSaveText}
        onClick={this.save}
      />
    ) : (
      <FlatButton
        icon={<ContentSave />}
        label={translate('save')}
        onClick={this.save}
        primary
      />
    );
    const cancelAction = (
      <FlatButton
        label={translate('cancel')}
        onClick={onClose}
        primary
      />
    );

    const actions = [
      cancelAction,
      saveAction,
    ];

    return (
      <Dialog
        style={{ ...styles.baseContainer, ...style }}
        bodyStyle={styles.baseContainer}
        title={titleNode}
        open={open}
        actions={onRemove ? [removeAction, ...actions] : actions}
        modal
      >
        {this.state.showSpinner && <Spinner />}
        {children}
      </Dialog>
    );
  }
}

DialogForm.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  icon: PropTypes.node,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default t(DialogForm);
